<template>
  <Frame>
    <PageHeader :title="$t('comm.orderImport')" :hasBack="false"/>
    <div class="list-contain" v-loading="tableLoading">
      <div class="head-contain">
        <div class="filter-contain">
          <el-upload action="/" :show-file-list="false" :http-request="uploadFile">
            <el-button type="primary" icon="el-icon-folder-opened">{{$t('comm.browseFile')}}</el-button>
            <div slot="tip" class="el-upload__tip">{{$t('orderImport.fileTypeLab')}}.xls/.xlsx</div>
          </el-upload>
        </div>

        <div class="filter-contain">
             <a href="/templet.xlsx" :download="$t('orderImport.downloadName')">{{$t('orderImport.downloadLab')}}</a>
        </div>
      </div>
    </div>
  </Frame>
</template>
<script>
import { listMixin } from "@/agency/mixin/mixin.js";
import { datePickerOptions } from "@/utils/handleDate";
export default {
  name: "OrderImport",
  mixins: [listMixin],
  data() {
    return {
    tableLoading:false
    };
  },
  mounted() {
    //this.frameOnResize(315);
  },
  created() {},
  methods: {
    uploadFile(param) {
      this.tableLoading=true;
      this.axiosInvoke(
        this.sysHandlerUrl + "?action=inputreport",
        param,
        (res, errflag) => {
          if (res.data.finish) {
              this.$alert(res.data.finish, this.$t("comm.tip"),{
                confirmButtonText: this.$t("comm.confirm"),
              });
          } else {
              this.$alert(this.$t("comm.uploadSuccess"), this.$t("comm.tip"),{
                confirmButtonText: this.$t("comm.confirm"),
              });
          }
          this.tableLoading=false;
        },
        true
      );
    }
  }
};
</script>
<style scoped>
.list-contain {
  display: flex;
  padding: 18px 0px;
}
.head-contain {
  padding: 0 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.filter-contain {
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 16px;
}
.filter-contain > span {
  color: #5d5d5d;
  font-size: 14px;
  margin: auto;
  white-space: nowrap;
}
.el-upload__tip{
    color: red;
    font-weight: bold;
}
.filter-contain a{
  text-decoration: none;
  font-size: 14px;
  color: #409EFF;
  margin: auto;
  white-space: nowrap;
}
</style>
